import { RulesetResult } from '../../business/rules';
import { PgExtension2YearsAgoRuleset } from '../../business/ruleset';
import { taxDocuments } from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';

const { pgExtension2YearsAgo } = taxDocuments;

export class PgExtension2YearsAgoValidation implements ValidationSchema {
  public name = pgExtension2YearsAgo.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'object';
  public required = {
    message: '',
    value: false,
  };
  public nullable = false;

  public ruleset = PgExtension2YearsAgoRuleset;
  public when(schema: any, ...args: any[]) {
    return schema.test({
      name: 'pgExtension2YearsAgoValidation',
      test: function (value, context) {
        // from[3] = full application, from[2] = current principal
        const application: Partial<ApplicationFormValues> =
          this.from?.[3]?.value ?? {};
        const principal = this.from?.[2]?.value;
        const principalId = principal?.id;

        const result: RulesetResult =
          PgExtension2YearsAgoRuleset.setPrincipalId(principalId).evaluate(
            application
          );

        const required = !!(result & RulesetResult.REQUIRED);

        if (!required) return true;

        const files = value?.files;
        if (!files || files.length === 0) {
          return this.createError({
            message: 'This document is required',
            path: context.path,
          });
        }
        if (!files[0]?.file_name) {
          return this.createError({
            message: 'This document is required',
            path: context.path,
          });
        }
        return true;
      },
    });
  }
}

export default new Validation(new PgExtension2YearsAgoValidation());
